@if (combinedDefinitionsAndGroups$ | async) {
  @for (
    reportGroupWithDefinition of reportGroupsWithDefinitions;
    track reportGroupWithDefinition
  ) {
    <app-report-group
      [reportGroupWithDefinitions]="reportGroupWithDefinition"
    />
  }
}
